import { render, staticRenderFns } from "./ProductData.vue?vue&type=template&id=6f7322f4&scoped=true&"
import script from "./ProductData.vue?vue&type=script&lang=js&"
export * from "./ProductData.vue?vue&type=script&lang=js&"
import style0 from "./ProductData.vue?vue&type=style&index=0&id=6f7322f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7322f4",
  null
  
)

export default component.exports